import {
    SolicitationFinancePreferences,
    SolicitationFinancePreferencesFields
} from "../../../../../types/financing/financingData";
import {Divider, Grid} from "@mui/material";
import {LabelWithData} from "../../../../../components/forms/LabelWithData";
import {useEffect, useState} from "react";
import {Bank} from "../../../../../types/generalData";
import {HttpCacheClientFolder} from "../../../../../http/cache/client/httpCacheClientFolder";
import {HttpCacheOperation} from "../../../../../http/cache/httpCacheOperation";
import {HttpCacheGeneral} from "../../../../../http/cache/httpCacheGeneral";
import {
    EntityWithIdAndDescription,
    EntityWithIdAndDescriptionFields,
    EntityWithIdFields
} from "../../../../../types/baseEntities";
import {HttpCacheAmortization} from "../../../../../http/cache/httpCacheAmortizationSystem";
import {FontSubtitleTwo} from "../../../../solicitation-new/components/SharedTypography";
import {OperationReasonDestination, OperationReasonDestinationFields} from "../../../../../types/operationData";


interface SolicitationFinancePreferencesDataProps {
    preferences: SolicitationFinancePreferences
}

const SolicitationFinancePreferencesData = ({preferences}: SolicitationFinancePreferencesDataProps) => {
    const [commercial, setCommercial] = useState<EntityWithIdAndDescription>()
    const [rateType, setRateType] = useState<EntityWithIdAndDescription>()
    const [amortizationType, setAmortizationType] = useState<EntityWithIdAndDescription>()
    const [bank, setBank] = useState<Bank>()
    const [periodicity, setPeriodicity] = useState<EntityWithIdAndDescription>()
    const [reasonDestination, setReasonDestination] = useState<string>('')
    const [destination, setDestination] = useState<string>('')

    useEffect(() => {
        HttpCacheOperation.getDestinations().then((dests) => {
            HttpCacheOperation.getReasonsDestination().then((reasons) => {
                const reason: OperationReasonDestination | undefined = reasons.find((reason) => reason[EntityWithIdFields.Id] === preferences[SolicitationFinancePreferencesFields.DestinationReasonCode])
                if (reason) {
                    const dest: EntityWithIdAndDescription | undefined = dests.find((des) => des[EntityWithIdFields.Id] === reason[OperationReasonDestinationFields.OperationDestinationCode])
                    if (dest) {
                        setDestination(dest[EntityWithIdAndDescriptionFields.Description])
                    }
                    setReasonDestination(reason[EntityWithIdAndDescriptionFields.Description])
                }
            })
        })

    }, [])
    
    useEffect(() => {
        HttpCacheClientFolder.getComerciales().then((res) => {
            setCommercial(res.find(com => com[EntityWithIdFields.Id] === preferences[SolicitationFinancePreferencesFields.CommercialCode]))
        })
        HttpCacheOperation.getRateModes().then((res) => {
            setRateType(res.find(type => type[EntityWithIdFields.Id] === preferences[SolicitationFinancePreferencesFields.RateTypeCode]))
        })
        HttpCacheAmortization.getAmortizationTypes().then((res) => {
            setAmortizationType(res.find(amort => amort[EntityWithIdFields.Id] === preferences[SolicitationFinancePreferencesFields.AmortizationSystemCode]))
        })
        HttpCacheGeneral.getBanks().then((res) => {
            setBank(res.find(bank => bank[EntityWithIdFields.Id] === preferences[SolicitationFinancePreferencesFields.BankCode]))
        })
        HttpCacheOperation.getPeriodicity().then((res) => {
            setPeriodicity(res.find(period => period[EntityWithIdFields.Id] === preferences[SolicitationFinancePreferencesFields.PeriodicityCode]))
        })
    }, [])
    
    return (
        <Grid container spacing={4} mt={4}>
            <Grid item md={12}>
                <FontSubtitleTwo text={'Financiamiento Solicitado'} />
            </Grid>
            <Grid item md={12}>
                <Divider/>
            </Grid>
            <Grid item md={3}>
                <LabelWithData label={'Oficial Comercial de FOGABA'} value={commercial ? commercial[EntityWithIdAndDescriptionFields.Description] : '-'}/>
            </Grid>
            <Grid item md={3}>
                <LabelWithData label={'Banco de Preferencia'} value={bank ? bank[EntityWithIdAndDescriptionFields.Description] : '-'}/>
            </Grid>
            <Grid item md={3}>
                {
                    (destination !== '' && reasonDestination !== '') ?
                    <LabelWithData label={'Destino del financiamiento'} value={`${reasonDestination} (${destination})`}/>
                        :
                        <LabelWithData label={'Destino del financiamiento'} value={'Sin especificar'}/>
                }
            </Grid>
            <Grid item md={3}>
                <LabelWithData label={'Línea'} value={preferences[SolicitationFinancePreferencesFields.Line]}/>
            </Grid>
            <Grid item md={3}>
                <LabelWithData label={'Monto del crédito solicitado'}
                               value={preferences[SolicitationFinancePreferencesFields.Amount]}
                               codCurrency={'$'}
                               format={'number'}
                />
            </Grid>
            <Grid item md={3}>
                <LabelWithData label={'Plazo de la operación'} value={`${preferences[SolicitationFinancePreferencesFields.Term] ?
                    `${preferences[SolicitationFinancePreferencesFields.Term]} meses` : `Sin especificar`}`} />
            </Grid>
            <Grid item md={3}>
                <LabelWithData label={'Tasa de interés'}
                               value={preferences[SolicitationFinancePreferencesFields.Rate]}
                               codCurrency={'%'}
                               format={'number'}
                />
            </Grid>
            <Grid item md={3}>
                <LabelWithData label={'Comentarios adicionales'} value={preferences[SolicitationFinancePreferencesFields.Comments]}/>
            </Grid>
            <Grid item md={3}>
                <LabelWithData label={'Monto de la garantía solicitada'}
                               value={preferences[SolicitationFinancePreferencesFields.Guarantee]}
                               codCurrency={'$'}
                               format={'number'}
                />
            </Grid>
            <Grid item md={3}>
                <LabelWithData label={'Período de Gracia'} value={`${preferences[SolicitationFinancePreferencesFields.GraceMonths]} meses`} />
            </Grid>
            <Grid item md={3}>
                <LabelWithData label={'Tasa (T.N.A.)'} value={rateType ? rateType[EntityWithIdAndDescriptionFields.Description]: '-'} />
            </Grid>
            <Grid item md={3}>
                <LabelWithData label={'Sistema de Amortización'} value={amortizationType ? amortizationType[EntityWithIdAndDescriptionFields.Description] : '-'}/>
            </Grid>
            <Grid item md={3}>
                <LabelWithData label={'Código de elegibilidad'} 
                               value={
                    preferences[SolicitationFinancePreferencesFields.EligibilityCode] ? preferences[SolicitationFinancePreferencesFields.EligibilityCode] : '-'
                } />
            </Grid>
            <Grid item md={3}>
                <LabelWithData label={'Periodicidad'} value={periodicity ? periodicity[EntityWithIdAndDescriptionFields.Description] : '-'} />
            </Grid>
        </Grid>
    )
}


export default SolicitationFinancePreferencesData